// Update contents object below

const contents = {
  header: 'Destination Canada',
  logoTooltip: {
    href: 'https://us-keepexploring.canada.travel/',
    copy: 'https://us-keepexploring.canada.travel/',
    logoPlacement: 'above'
  },
  video:
    'https://player.vimeo.com/video/927587472?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  videoTitle: 'Destination Canada - Ep.6  Alberta',
  videoAutoPlay: true,
  title: 'episode 6: Alberta',
  copy:
    'This consummate outdoor athlete is known for her backcountry skills and her partnership with organizations around the world that focus on conservation and climate regeneration. Together with Dani we experience the majestic and awe-inspiring winter of Alberta, Canada.',
  url: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/',
  button: 'return to hub'
};

export default contents;
